import { Box } from "@mui/material";
import Iconify from "src/components/Iconify";
import { IconButtonAnimate } from "src/components/animate";

type Props = {
    onToggleCollapse: VoidFunction;
    collapseClick: boolean;
};

export default function CollapseButton({ onToggleCollapse, collapseClick }: Props) {
    return (
        <IconButtonAnimate onClick={onToggleCollapse} size="small" sx={{ p: 0 }}>
            <Box
                sx={{
                    lineHeight: 0,
                    transition: (theme) =>
                        theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                        }),
                    ...(collapseClick && {
                        transform: "rotate(180deg)",
                    }),
                }}
            >
                <Iconify icon={"eva:chevron-left-fill"} width={24} height={24} />
            </Box>
        </IconButtonAnimate>
    );
}
